module.exports = __webpack_public_path__ + "assets/img/news3.1.90ea810a.png";